import * as React from 'react';

type Props = {
  className?: string
}

export default ({ className }: Props) => {
    return (
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="32"
          height="32"
          viewBox="0 0 32 32"
          className={className}
        >
          <path d="M32 29H0v2h32v-2zM10 5H6a1 1 0 00-1 1v20a1 1 0 001 1h4a1 1 0 001-1V6a1 1 0 00-1-1zM9 25H7V7h2v18zM18 15h-4a1 1 0 00-1 1v10a1 1 0 001 1h4a1 1 0 001-1V16a1 1 0 00-1-1zm-1 10h-2v-8h2v8zM26 1h-4a1 1 0 00-1 1v24a1 1 0 001 1h4a1 1 0 001-1V2a1 1 0 00-1-1zm-1 24h-2V3h2v22z"></path>
        </svg>
    );
};
